<ng-container >
  <button mat-button aria-label="form.name" class="form-btn" (click)="openForm($event)">
  <span *ngIf="showIcon">
    <mat-icon
      *ngIf="!form.faIcon; else faIconTemplate"
      class="form-link"
      [ngClass]="form.icon"
    ></mat-icon>
    <ng-template #faIconTemplate>
      <fa-icon class="form-link" [icon]="form.faIcon"></fa-icon>
    </ng-template>
  </span>
    <span class="form-link-title">{{ displayName }}</span>
  </button>
</ng-container>
